import React from 'react';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { Icon } from '@fluentui/react';

export const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return result;
};

const SortableUnitList = ({ units, onReorder }) => {
    const handleDragEnd = (result) => {
        if (!result.destination || result.destination.index === result.source.index) {
            return;
        }

        onReorder(reorder(units, result.source.index, result.destination.index));
    };

    return (
        <DragDropContext onDragEnd={handleDragEnd}>
            <Droppable droppableId="signup-units">
                {(droppableProvided) => (
                    <div
                        ref={droppableProvided.innerRef}
                        {...droppableProvided.droppableProps}
                        style={{ border: '1px solid #e1e1e1', borderRadius: 2 }}
                    >
                        {units.map((unit, index) => (
                            <Draggable
                                key={unit.clientSchoolID}
                                draggableId={String(unit.clientSchoolID)}
                                index={index}
                            >
                                {(draggableProvided, snapshot) => (
                                    <div
                                        ref={draggableProvided.innerRef}
                                        {...draggableProvided.draggableProps}
                                        {...draggableProvided.dragHandleProps}
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            padding: '10px 12px',
                                            borderBottom: '1px solid #f0f0f0',
                                            background: snapshot.isDragging ? '#eff6fc' : '#ffffff',
                                            boxShadow: snapshot.isDragging ? '0 2px 8px rgba(0,0,0,0.15)' : 'none',
                                            cursor: 'grab',
                                            ...draggableProvided.draggableProps.style,
                                        }}
                                    >
                                        <Icon
                                            iconName="GripperDotsVertical"
                                            styles={{ root: { marginRight: 10, color: '#888' } }}
                                        />
                                        <span
                                            style={{
                                                minWidth: 28,
                                                color: '#666',
                                                fontVariantNumeric: 'tabular-nums',
                                            }}
                                        >
                                            {index + 1}.
                                        </span>
                                        <span>{unit.name}</span>
                                    </div>
                                )}
                            </Draggable>
                        ))}
                        {droppableProvided.placeholder}
                    </div>
                )}
            </Droppable>
        </DragDropContext>
    );
};

export default SortableUnitList;
